var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import * as AccountResources from "../../../constants/accountResourceNames";
import { HUMO, EXPAY_SUB_TOKEN_OPTIONS } from "../../../constants/expaySubToken";
import copyIcon from "../../../assets/img/icon-copy.svg";
import { SubmitButton } from "../../shared/ui";
var messages = defineMessages({
    min: {
        id: "recharge.min_value",
        defaultMessage: "минимальная сумма {min}"
    },
    max: {
        id: "recharge.max_value",
        defaultMessage: "максимальная сумма {max}"
    },
    required: {
        id: "recharge.required",
        defaultMessage: "Обязательное поле"
    },
    serverError: {
        id: "member-area.selfblocking_server_error",
        defaultMessage: "Что-то пошло не так, попробуйте позже"
    }
});
var PRESET_AMOUNTS = [30000, 50000, 150000, 300000, 500000];
var MIN_AMOUNT = 30000;
var MAX_AMOUNT = 2000000;
var TIMER_DURATION_MS = 20 * 60 * 1000;
var AMOUNT_KEY = "expay_recharge_amount";
var SUB_TOKEN_KEY = "expay_recharge_sub_token";
var getInitialSubToken = function () {
    var stored = localStorage.getItem(SUB_TOKEN_KEY);
    if (stored === null) {
        return HUMO;
    }
    var parsed = Number(stored);
    return EXPAY_SUB_TOKEN_OPTIONS.some(function (option) { return option.value === parsed; })
        ? parsed
        : HUMO;
};
var formatNumber = function (num) { return Intl.NumberFormat("ru").format(num); };
var ExpayForm = /** @class */ (function (_super) {
    __extends(ExpayForm, _super);
    function ExpayForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: localStorage.getItem(AMOUNT_KEY) || String(PRESET_AMOUNTS[0]),
            subToken: getInitialSubToken(),
            error: "",
            timer: "20:00",
            isTimerExpired: false,
            copied: false
        };
        _this.tickTimer = function () {
            var createdAt = _this.props.expay.get("createdAt");
            var refer = _this.props.expay.get("refer");
            if (!refer || !createdAt) {
                return;
            }
            var remaining = createdAt + TIMER_DURATION_MS - Date.now();
            if (remaining <= 0) {
                _this.setState({ timer: "00:00", isTimerExpired: true });
                return;
            }
            var minutes = Math.floor(remaining / 1000 / 60);
            var seconds = Math.floor((remaining / 1000) % 60);
            _this.setState({
                timer: "".concat(minutes < 10 ? "0".concat(minutes) : minutes, ":").concat(seconds < 10 ? "0".concat(seconds) : seconds),
                isTimerExpired: false
            });
        };
        _this.handleSubTokenChange = function (e) {
            var subToken = Number(e.target.value);
            localStorage.setItem(SUB_TOKEN_KEY, String(subToken));
            _this.setState({ subToken: subToken });
        };
        _this.handleChange = function (value) {
            var parsedValue = String(value)
                .replace(/\D/gi, "")
                .slice(0, 7);
            localStorage.setItem(AMOUNT_KEY, parsedValue);
            _this.setState({
                error: "",
                value: parsedValue
            });
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            var value = _this.state.value;
            var _a = _this.props, user = _a.user, intl = _a.intl, rechargeExpay = _a.rechargeExpay;
            var amount = Number(value);
            if (!value) {
                return _this.setState({
                    error: intl.formatMessage(messages.required)
                });
            }
            if (amount < MIN_AMOUNT) {
                return _this.setState({
                    error: intl.formatMessage(messages.min, {
                        min: formatNumber(MIN_AMOUNT)
                    })
                });
            }
            if (amount > MAX_AMOUNT) {
                return _this.setState({
                    error: intl.formatMessage(messages.max, {
                        max: formatNumber(MAX_AMOUNT)
                    })
                });
            }
            rechargeExpay({
                Requisite: user.gamblerId,
                ResourceId: AccountResources.UZ,
                Amount: amount,
                SubToken: _this.state.subToken,
                RedirectUrl: "".concat(window.origin, "/recharge/success?amount=").concat(amount)
            });
        };
        _this.handleCopyRefer = function () {
            var refer = _this.props.expay.get("refer");
            if (!refer) {
                return;
            }
            var el = document.createElement("textarea");
            el.value = refer;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            _this.setState({ copied: true });
            clearTimeout(_this.copiedTimeout);
            _this.copiedTimeout = setTimeout(function () {
                _this.setState({ copied: false });
            }, 2000);
        };
        _this.handleCreateNewRequest = function () {
            _this.props.clearRechargeExpay();
            _this.setState({ isTimerExpired: false, timer: "20:00" });
        };
        _this.handleCheckStatus = function () {
            var invoiceId = _this.props.expay.get("invoiceId");
            if (!invoiceId) {
                return;
            }
            _this.props.checkExpayStatus(invoiceId);
        };
        _this.getPaymentSystemMessageId = function (subToken) {
            var option = EXPAY_SUB_TOKEN_OPTIONS.find(function (item) { return item.value === subToken; });
            return option ? option.messageId : EXPAY_SUB_TOKEN_OPTIONS[0].messageId;
        };
        return _this;
    }
    ExpayForm.prototype.componentDidMount = function () {
        this.timerInterval = setInterval(this.tickTimer, 1000);
    };
    ExpayForm.prototype.componentWillUnmount = function () {
        clearInterval(this.timerInterval);
        clearTimeout(this.copiedTimeout);
    };
    ExpayForm.prototype.componentDidUpdate = function (prevProps) {
        var prevRefer = prevProps.expay.get("refer");
        var refer = this.props.expay.get("refer");
        if (!prevRefer && refer) {
            this.setState({ isTimerExpired: false, timer: "20:00" });
        }
        var prevCheckStatus = prevProps.expay.get("checkStatus");
        var checkStatus = this.props.expay.get("checkStatus");
        if (prevCheckStatus !== checkStatus && checkStatus === "SUCCESS") {
            var amount = this.props.expay.get("amount");
            this.props.history.push("/recharge/success?amount=".concat(amount));
        }
    };
    ExpayForm.prototype.renderAmountForm = function () {
        var _this = this;
        var _a = this.state, value = _a.value, subToken = _a.subToken, error = _a.error;
        var fetching = this.props.expay.get("fetching");
        var apiError = this.props.expay.get("error");
        var disabled = !value || error || fetching;
        var inputCls = error ? "input error" : "input";
        return (_jsxs("div", __assign({ className: "wrapper" }, { children: [_jsx("p", __assign({ className: "usdt-form__title", style: { marginBottom: "8px" } }, { children: _jsx(FormattedMessage, { id: "expay.choose_card_type" }) })), _jsx("div", __assign({ className: "input input-select" }, { children: _jsx("select", __assign({ value: subToken, onChange: this.handleSubTokenChange }, { children: EXPAY_SUB_TOKEN_OPTIONS.map(function (option) { return (_jsx("option", __assign({ value: option.value }, { children: _this.props.intl.formatMessage({ id: option.messageId }) }), option.value)); }) })) })), _jsx("p", __assign({ className: "usdt-form__title", style: { marginBottom: "8px" } }, { children: _jsx(FormattedMessage, { id: "recharge.expay.min_amount" }) })), _jsxs("div", __assign({ className: inputCls }, { children: [_jsx("input", { type: "tel", max: 7, placeholder: this.props.intl.formatMessage({
                                id: "recharge.enter_amount"
                            }), value: value !== "" ? formatNumber(value) : "", onChange: function (e) { return _this.handleChange(e.target.value); } }), _jsx("div", __assign({ className: "placeholder" }, { children: "UZS" })), error && _jsx("div", { className: "error-icon" }), error && _jsx("div", __assign({ className: "error" }, { children: error }))] })), _jsx("div", __assign({ className: "grid" }, { children: PRESET_AMOUNTS.map(function (i) { return (_jsx("div", __assign({ className: formatNumber(i) === formatNumber(value)
                            ? "grid_control active"
                            : "grid_control", onClick: function () { return _this.handleChange(i); } }, { children: formatNumber(i) }), i)); }) })), apiError && (_jsx("p", __assign({ className: "error", style: { marginTop: "12px", textAlign: "center" } }, { children: _jsx(FormattedMessage, __assign({}, messages.serverError)) }))), _jsx("p", __assign({ className: "usdt-form__descr", style: { marginTop: "16px" } }, { children: _jsx(FormattedMessage, { id: "recharge.expay.min_amount_warning" }) })), _jsx("div", __assign({ className: "controls" }, { children: _jsx(SubmitButton, __assign({ disabled: disabled, loading: fetching, onClick: this.handleSubmit, className: "singlebet_submit" }, { children: _jsx(FormattedMessage, { id: "recharge.deposit" }) })) }))] })));
    };
    ExpayForm.prototype.renderPaymentScreen = function () {
        var expay = this.props.expay;
        var refer = expay.get("refer");
        var amount = expay.get("amount");
        var subToken = expay.get("subToken");
        var invoiceId = expay.get("invoiceId");
        var checkStatus = expay.get("checkStatus");
        var checking = expay.get("checking");
        var _a = this.state, timer = _a.timer, isTimerExpired = _a.isTimerExpired, copied = _a.copied;
        if (isTimerExpired) {
            return (_jsxs("div", __assign({ className: "usdt-form", style: { padding: "20px 15px" } }, { children: [_jsx("p", __assign({ className: "usdt-form__submit_info", style: { textAlign: "center" } }, { children: _jsx(FormattedMessage, { id: "recharge.expay.timer_expired" }) })), _jsx("div", __assign({ className: "controls", style: { marginTop: "20px" } }, { children: _jsx("button", __assign({ className: "singlebet_submit", onClick: this.handleCreateNewRequest }, { children: _jsx(FormattedMessage, { id: "recharge.expay.create_new_request" }) })) }))] })));
        }
        return (_jsxs("div", __assign({ className: "usdt-form", style: { padding: "0 15px 20px" } }, { children: [_jsxs("p", __assign({ className: "usdt-form__submit_timer", style: {
                        fontSize: "16px",
                        textAlign: "center",
                        fontWeight: "600",
                        marginTop: "12px"
                    } }, { children: [_jsx(FormattedMessage, { id: "recharge.expay.awaiting_payment" }), ": ", timer] })), amount != null && (_jsxs("p", __assign({ className: "usdt-form__submit_info", style: { textAlign: "center" } }, { children: [_jsx(FormattedMessage, { id: "recharge.expay.recharge_amount" }), ":", " ", formatNumber(amount), " UZS"] }))), subToken != null && (_jsxs("p", __assign({ className: "usdt-form__submit_info", style: { textAlign: "center" } }, { children: [_jsx(FormattedMessage, { id: "recharge.expay.payment_system" }), ":", " ", _jsx(FormattedMessage, { id: this.getPaymentSystemMessageId(subToken) })] }))), _jsx("p", __assign({ className: "usdt-form__submit_info", style: { textAlign: "center" } }, { children: _jsx(FormattedMessage, { id: "recharge.expay.after_transfer" }) })), refer && (_jsxs("div", __assign({ className: "usdt-form__submit_refer_block" }, { children: [_jsx("p", __assign({ className: "usdt-form__submit_refer_title" }, { children: _jsx(FormattedMessage, { id: "recharge.expay.refer" }) })), _jsxs("div", __assign({ className: "usdt-form__submit_refer_wrap" }, { children: [copied && (_jsx("span", __assign({ className: "usdt-form__submit_refer_copied" }, { children: _jsx(FormattedMessage, { id: "recharge.expay.refer_copied", defaultMessage: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E" }) }))), _jsx("p", __assign({ className: "usdt-form__submit_refer" }, { children: refer })), _jsx("button", __assign({ type: "button", className: "usdt-form__submit_refer_copy", onClick: this.handleCopyRefer }, { children: _jsx("img", { src: copyIcon, alt: "copy" }) }))] }))] }))), checkStatus === "ACCEPTED" && (_jsx("p", __assign({ className: "usdt-form__submit_info", style: { textAlign: "center" } }, { children: _jsx(FormattedMessage, { id: "recharge.expay.status_pending" }) }))), checkStatus === "ERROR" && (_jsx("p", __assign({ className: "usdt-form__submit_info", style: { textAlign: "center", color: "tomato" } }, { children: _jsx(FormattedMessage, { id: "recharge.expay.status_error" }) }))), _jsxs("div", __assign({ className: "usdt-form__submit" }, { children: [_jsx(SubmitButton, __assign({ className: "usdt-form__submit_button", onClick: this.handleCheckStatus, disabled: !invoiceId, loading: checking }, { children: _jsx(FormattedMessage, { id: "recharge.expay.transfer_completed" }) })), _jsx("button", __assign({ className: "usdt-form__submit_cancel", onClick: this.props.handleClearSelect }, { children: _jsx(FormattedMessage, { id: "recharge.expay.cancel" }) }))] })), _jsx("p", __assign({ className: "usdt-form__submit_info", style: { marginTop: "16px" } }, { children: _jsx(FormattedMessage, { id: "recharge.expay.support_hint" }) })), _jsx("p", __assign({ className: "usdt-form__submit_info" }, { children: _jsx(FormattedMessage, { id: "recharge.expay.payment_timeout" }) }))] })));
    };
    ExpayForm.prototype.render = function () {
        var refer = this.props.expay.get("refer");
        if (refer) {
            return this.renderPaymentScreen();
        }
        return this.renderAmountForm();
    };
    return ExpayForm;
}(React.Component));
export default withRouter(injectIntl(ExpayForm));



// WEBPACK FOOTER //
// ./src/components/recharge/forms/ExpayForm.jsx